import { ButtonLinkRebrand } from 'src/components/atoms/ButtonRebrand'
import { Card } from 'src/components/atoms/Card'
import { OnClickLink } from 'src/components/atoms/Link'
import { Heading4, ParagraphNoSpace } from 'src/components/atoms/Typography'

import { createProjectPath } from 'src/config/paths'
import { useMessenger } from 'src/hooks/useMessenger'

type NewProjectCardProps = {
  returnUrl: string
}

const NewProjectCard = ({ returnUrl }: NewProjectCardProps) => {
  const { showNewMessage } = useMessenger()
  return (
    <Card size='large'>
      <Heading4 className='text-[20px]! leading-[26px]! font-bold!'>
        Have a new project?
      </Heading4>
      <div className='flex flex-col gap-5'>
        <ParagraphNoSpace className='text-[14px]! leading-[20px]! md:text-[16px]! md:leading-[24px]! font-medium!'>
          A &apos;project&apos; involves a series of plantings with shared goals
          to restore or reforest an area. It may span multiple addresses,
          locations and years, often including various planting sites to achieve
          the restoration goal.
        </ParagraphNoSpace>
        <ParagraphNoSpace className='text-[14px]! leading-[20px]! md:text-[16px]! md:leading-[24px]! font-medium!'>
          Not sure if you need to create a new project? Reach out to our team,
          we’re here to help.
        </ParagraphNoSpace>
        <div className='flex flex-row items-center justify-start gap-[10px]'>
          <ButtonLinkRebrand
            variant='outline'
            href={createProjectPath({
              queryParams: {
                returnUrl
              }
            })}
          >
            Create a new project
          </ButtonLinkRebrand>
          <OnClickLink
            color='forestDeep'
            className='underline'
            onClick={() => {
              showNewMessage()
            }}
          >
            Talk to the team
          </OnClickLink>
        </div>
      </div>
    </Card>
  )
}

export default NewProjectCard
